import { MANUAL_CHARGE_TYPES } from "../constants/guidelineCharges";

export const MANUAL_CHARGE_TYPE_OPTIONS = MANUAL_CHARGE_TYPES.map((charge) => ({
  id: charge.id,
  name: charge.label,
}));

export const LOG_FIELD_LABELS = {
  chargeType: "Charge Type",
  description: "Charge Description",
  client: "Client Name",
  checkType: "Check Type",
  amountCharged: "Total Amount",
  date: "Date",
  notes: "Additional Notes",
  billingMonth: "Billing Month",
  currentMonthlyRepaymentAmount: "Current Monthly Repayment Amount",
  totalRepaymentAmount: "Total Repayment Amount",
  totalInterest: "Total Interest",
};

export const formatChargeDateTime = (value) => {
  if (!value) return "-";
  const date = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime())
    ? "-"
    : date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

const today = () => new Date().toISOString().slice(0, 10);
const dateInputValue = (value) => String(value || "").slice(0, 10);
export const priceIncreaseDescription = (date) => {
  const [year, month] = dateInputValue(date).split("-").map(Number);
  if (!year || !month) return "";
  const previousMonth = new Date(year, month - 2, 1).toLocaleDateString(
    "en-GB",
    { month: "short" },
  );
  return `${previousMonth} price increase`;
};

export const formFromManualCharge = (charge, defaultDate, defaultRecurringDate) => {
  const date = dateInputValue(charge?.date) || dateInputValue(defaultDate) || today();
  return {
    date,
    chargeType: charge?.manualChargeTypeId || charge?.chargeTypeId || "",
    description: charge?.description || "",
    client: charge?.client || charge?.clientName || "",
    checkType:
      charge?.checkType ||
      MANUAL_CHARGE_TYPES.find(
        (item) =>
          item.id === (charge?.manualChargeTypeId || charge?.chargeTypeId),
      )?.checkType ||
      "",
    totalAmount:
      charge?.totalAmountCharged == null && charge?.amountCharged == null
        ? ""
        : String(charge?.totalAmountCharged ?? charge?.amountCharged),
    notes: charge?.notes || "",
    chargeFrom:
      dateInputValue(charge?.chargeFrom) || dateInputValue(defaultRecurringDate),
    chargeTo: dateInputValue(charge?.chargeTo),
    repaymentInstalments:
      charge?.repaymentInstalments || charge?.repaymentInstallments || "",
    annualInterestRatePa:
      charge?.annualInterestRatePa || charge?.annualInterestRate || "",
    annualBasicLoanFee: charge?.annualBasicLoanFee || "",
    monthlyInterestRatePm:
      charge?.monthlyInterestRatePm || charge?.monthlyInterestRate || "",
    monthlyInterestAmount: charge?.monthlyInterestAmount || "",
    monthlyRepaymentAmount:
      charge?.monthlyRepaymentAmount || charge?.monthlyChargeableAmount || "",
    currentMonthlyRepaymentAmount: charge?.currentMonthlyRepaymentAmount || "",
    currentRepaymentInstalment:
      charge?.currentRepaymentInstalment ||
      charge?.currentRepaymentInstallments ||
      "",
    currentBalanceRemaining: charge?.currentBalanceRemaining || "",
    totalRepaymentAmount: charge?.totalRepaymentAmount || "",
    totalInterest: charge?.totalInterest || "",
    annualBoeBaseRatePa:
      charge?.annualBoeBaseRatePa || charge?.bankOfEnglandRate || "",
  };
};
